import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Container, Input, ModalBody, Alert, Modal, ModalFooter } from 'reactstrap';

import Page from '../../components/Layout/Page/Page';
import Loader from '../../components/Common/Loader';
import UserRow from '../../components/Users/UserRow/UserRow';
import RoundedButton from '../../components/Buttons/RoundedButton/RoundedButton';

import * as usersAPI from '../../helpers/api/users.api';

import '../Tracks/Tracks.scss';

const AdminScouts = props => {
    const [loading, setLoading] = useState(false);
    const [scouts, setScouts] = useState([]);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [creating, setCreating] = useState(false);
    const [loadingCreating, setLoadingCreating] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        loadScouts();
    }, []);

    async function loadScouts() {
        setLoading(true);
        usersAPI.loadScouts()
            .then((result) => {
                if (result.success) {
                    setScouts(result.users);
                } else {
                    setScouts([]);
                }
                setLoading(false);
            })
            .catch((error) => {
                setScouts([]);
                setLoading(false);
                console.log(error);
            });
    }

    async function handleOnSubmit() {
        setLoadingCreating(true);

        // else lo stiamo creando
        usersAPI.createScout(name, email, password)
            .then((result) => {
                setLoadingCreating(false);
                if (result.success) {
                    setName('')
                    setEmail('')
                    setPassword('')
                    setSuccess(result.message);
                    loadScouts();
                    setTimeout(() => {
                        handleOnClose();
                    }, 2000);
                } else setError(result.message);
            })
            .catch((error) => {
                setLoadingCreating(false);
                setError(error.message);
            });

    }

    function handleOnClose() {
        setCreating(false);
        setError(null);
        setSuccess(null);
    }

    return <Page className="tracks">
        <Container fluid className="h-100 d-flex flex-column">
            <Row className='mb-2'>
                <Col className='d-flex align-items-center justify-content-end'>
                    <RoundedButton color="primary" onClick={() => setCreating(true)}>Crea Scout</RoundedButton>
                </Col>
            </Row>
            {loading ?
                <Loader />
                : scouts ? <>
                    <Row className="h-50 pt-3">
                        <Col className="h-100">
                            <ul className="users-list h-100">
                                {scouts.map(u => <UserRow key={u._id} user={u} />)}
                            </ul>
                        </Col>
                    </Row>
                </> : null}
        </Container>
        <Modal
            className='edit-scout-modal'
            isOpen={creating}
            autoFocus={true}
            centered={true}
            backdrop={true}
            toggle={handleOnClose}>
            <ModalBody>
                {loadingCreating ? (
                    <Loader className="p-5" />
                ) : success ? (
                    <Alert className="mb-4" color="success">
                        {success}
                    </Alert>
                ) : <>
                    <p className="error">{error}</p>
                    <Row>
                        <Col sm="12">
                            <h6 className='mb-3'>{'Crea scout'}</h6>
                            <p>
                                Nome
                            </p>
                            <Input
                                id="name"
                                name="name"
                                type="text"
                                className="form-control"
                                value={name || ''}
                                onChange={(event) =>
                                    setName(event.target.value)
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <p>
                                Indirizzo e-mail
                            </p>
                            <Input
                                id="email"
                                name="email"
                                type="email"
                                className="form-control"
                                value={email || ''}
                                onChange={(event) =>
                                    setEmail(event.target.value)
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <p>
                                Password
                            </p>
                            <Input
                                id="password"
                                name="password"
                                type="password"
                                className="form-control"
                                value={password || ''}
                                onChange={(event) =>
                                    setPassword(event.target.value)
                                }
                            />
                        </Col>
                    </Row>
                </>}
            </ModalBody>
            {!loadingCreating && !success && (
                <ModalFooter className='d-flex align-items-center'>
                    <RoundedButton
                        className="waves-effect px-5 m-0 mt-2 mb-2 mr-2 outline"
                        type="button"
                        color="secondary"
                        onClick={handleOnClose}>
                        Annulla
                    </RoundedButton>
                    <RoundedButton
                        className="waves-effect px-5 m-0 mt-2 mb-2 ml-2"
                        type="button"
                        color="primary"
                        onClick={handleOnSubmit}>
                        Crea
                    </RoundedButton>
                </ModalFooter>
            )}
        </Modal>
    </Page>;
}

const mapStatetoProps = (state) => {
    return { user: state.Auth.user };
};

export default connect(mapStatetoProps, {})(AdminScouts);